<template>
    <div class="backBox">
        <div class="pad">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getNoticeData">
                <div class="notice-box" v-for="(item,index) in noticeInfo" :key="index">
                    <div class="notice-time">{{item.dateStr}}</div>
                    <div class="notice-title">
                        <div class="title-left">
                            <img :src="item.iconPath">&nbsp;&nbsp;
                            <span>{{item.title}}</span>
                        </div>
<!--                        <div v-if="item.bizType==='Storage'" class="cabinet">-->
<!--                            存包格：1#-->
<!--                        </div>-->
                    </div>
                    <div class="notice-info">
                        {{item.details}}
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import api from "@/api/storage";
import { List ,Toast} from "vant";
export default {
    name: "Notice",
    components:{
        [List.name]:List
    },
    data(){
        return{
            loading:false,
            finished:false,
            page:0,
            pageSize:5,
            noticeInfo:[]
        }
    },
    methods:{
        getNoticeData(){
            api.getNotice({
                page:++this.page,
                pageSize:this.pageSize,
            }).then(res=>{
                if(res.result===0){
                    let self=this;
                    self.loading=false;
                    self.page=res.data.page;
                    if(res.data.result.length>0){
                        try {
                            res.data.result.forEach(function (n) {
                                self.noticeInfo.push(n);
                                if(self.noticeInfo.length<res.data.total){
                                    self.finished = false;
                                }else {
                                    throw "";
                                }
                            });
                        }catch (e) {
                            self.finished=true;
                        }
                    }else{
                        self.finished=true;
                    }
                }else {
                    Toast(res)
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import "../../../static/less/common";
.notice-box{
    margin-top: 45px;
    padding: 15px;
    border-radius: 16px;
    box-shadow: 0 2px 20px 0 rgba(0,0,0,0.05);
    position: relative;
    font-size: 14px;
}
.notice-time{
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    color: #999999;
    font-size: 12px;
}
.notice-title{
    .flex-center-Y;
    .title-left{
        .flex-center-Y;
    }
    justify-content: space-between;
    padding-bottom: 9px;
    border-bottom: 1px dashed #EAEAEA;
    img{
        width: 40px;
        border-radius: 40px;
    }
    .cabinet{
        color: #FFC340;
        font-size: 20px;
    }
}
.notice-info{
    padding: 20px 0 5px 0;
    line-height: 22px;
    color: #999999;
}
</style>
